'use strict';

var angular = require('angular');
var _ = require('lodash');
var RestangularConfig = function RestangularConfig(RestangularProvider) {
  function serviceUnavailableErrorCheck(status) {
    return status === 503;
  }
  RestangularProvider.setErrorInterceptor(function (response, deferred, responseHandler) {
    var $injector = angular.injector(['ng', 'AVRO.Common.Bootstrap']);
    var $http = $injector.get('$http');
    var PromiseRetry = $injector.get('PromiseRetry');
    var validateError = _.bind(serviceUnavailableErrorCheck, null, response.status);
    PromiseRetry.retry(function () {
      return $http(response.config);
    }, {
      retryLimit: 10,
      delay: 1000,
      success: responseHandler,
      error: deferred.reject,
      validate: validateError
    });
    return !validateError();
  });
};
RestangularConfig.$inject = ['RestangularProvider'];
module.exports = RestangularConfig;